<div class="scope-row-header flex items-center align-middle">
  <div
    class="column level-{{ level }}"
    [ngClass]="config?.mainColumnClass">
    <span>{{ 'deliverable|u' | lang }} NAME</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.DELIVERY_STATUS?.isVisible?.()">
    <span>Delivery Status</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.CREATED_BY?.selected">
    <span>Created by</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.OWNER?.selected">
    <span>Owner</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.DATE_CREATED?.selected">
    <span>Date Created</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.QUANTITY?.selected">
    <span>Quantity</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
    <span>Start Date</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.LAST_EDITED?.selected">
    <span>Last edited</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
    <span>End Date</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.MARK_UP?.selected"
    [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
    [has-privilege-entity]="config?.scopeVersion">
    <span>Markup</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.PROFIT?.selected"
    [has-privilege]="Privilege.SCOPE_MARKUP__VIEW"
    [has-privilege-entity]="config?.scopeVersion">
    <span>Profit</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
    <span isEllipsisActive>{{ 'scope_mark' | lang }}<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_HOURS?.selected">
    <span isEllipsisActive>{{ 'agency|p' | lang }}<br />hours</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.UNIT_PRICE?.selected">
    <span isEllipsisActive>Unit<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.BUDGET?.selected">
    <span>Budget</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.BALANCE?.selected">
    <span>Balance</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.userColumns.AGENCY_PRICE?.selected">
    <span isEllipsisActive>{{ 'agency|p' | lang }}<br />price</span>
  </div>
  <div
    class="column one--column"
    [hidden]="!config?.showActionsColumn"></div>
</div>
